import { ExerciseAbcBase } from './exerciseAbcBase';

export class ExerciseAbc1 extends ExerciseAbcBase {
  constructor() {
    super('ExerciseAbc1', 1);
  }
}
